// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4d332e4a","125":"798e4328","340":"1bb11c86","498":"ea180021","513":"aa0a5b19","703":"bdc5e107"}[chunkId] + ".chunk.js";
};